import { type CheckedChangedEventHandler, ChoiceListItem } from '@sunwebgroup/ui-components';
import { isEmpty } from 'ramda';

import { useSelectFilter } from '../../../../domain/hooks';
import { useIntl } from '@/intl';
import FilterGroup from './FilterGroup';
import { ShowMore } from '../../../../../../common/components/ShowMore';
import { createSearchFilterClickEvent } from '../../../../domain/analytics';
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks';
import { createSelectDateFilterActions } from '@/scopes/search/search/domain/actions/selectDateFilterActions';
import { useSearchDependencies } from '@/scopes/search/search/pages/SearchPage/context';

export function LastMinuteFilter() {
  const intl = useIntl();
  const { sendEvent } = useAnalytics();
  const { isFetching, options, selectedValue } = useSelectFilter('Lastminute');
  const { filterSelectionQueryParamHandler } = useSearchDependencies();
  const selectDepartureDateActions = createSelectDateFilterActions({ filterSelectionQueryParamHandler });

  const handleFilterChange: CheckedChangedEventHandler = ({ checked, value }) => {
    if (checked) {
      selectDepartureDateActions.setLastMinuteFilterSelection(value?.toString());

      sendEvent(
        createSearchFilterClickEvent({
          element: 'checkbox',
          type: 'departure weeks',
          result: value,
        })
      );
    } else {
      selectDepartureDateActions.setLastMinuteFilterSelection(undefined);
    }
  };

  if (isEmpty(options)) return null;

  return (
    <FilterGroup
      title={intl.formatMessage({ id: 'search_filter_last_minute_label' })}
      defaultOpen={selectedValue !== null}
    >
      <ShowMore
        openLabel={intl.formatMessage({ id: 'show_more' })}
        closeLabel={intl.formatMessage({ id: 'show_less' })}
      >
        {options.map(({ name, value, resultsCount }) => (
          <ChoiceListItem
            choiceListItemType="checkbox"
            key={name}
            value={value}
            label={name}
            checked={selectedValue === value}
            quantity={resultsCount}
            onCheckedChange={handleFilterChange}
            disabled={isFetching}
          />
        ))}
      </ShowMore>
    </FilterGroup>
  );
}
